import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import AppStoreButton from "@/components/AppStoreButton";

const INCLUDED = [
  "The Five seçimleri",
  "My Date deneyimi",
  "Çöpçatan desteği",
  "Geri bildirime dayalı kişiselleşme",
];

export default function Membership({ showLink = true }) {
  return (
    <section data-testid="membership-section" className="py-24 sm:py-36 bg-ivory">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <FadeUp>
            <Eyebrow>Üyelik</Eyebrow>
          </FadeUp>
          <h2 className="mt-7 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-ink">
            <MaskedLines
              lines={[
                "Daha seçici bir",
                <em key="em" className="italic text-burgundy">
                  dating deneyimi.
                </em>,
              ]}
            />
          </h2>
        </div>

        <FadeUp delay={0.2} className="mt-14 sm:mt-16">
          <div className="max-w-4xl bg-white/90 border border-burgundy/10 rounded-[6px] p-8 sm:p-12 grid sm:grid-cols-2 gap-10 shadow-[0_20px_50px_rgba(38,32,32,0.05)]">
            <div>
              <p className="text-[15px] font-light text-ink-soft/90 leading-relaxed">
                Üyelik, Five Star&rsquo;ın kişisel eşleşme sürecine erişim sağlar. Aktif üyelik süresince The Five
                seçimlerini, My Date deneyimini ve çöpçatan desteğini kullanabilirsin.
              </p>
              <ul className="mt-7 space-y-3.5">
                {INCLUDED.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[15px] text-ink-soft">
                    <span className="w-6 h-6 rounded-full border border-gold/50 flex items-center justify-center shrink-0">
                      <Check className="w-3.5 h-3.5 text-gold" aria-hidden="true" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col justify-between gap-8 sm:border-l sm:border-burgundy/10 sm:pl-10">
              <div className="space-y-3">
                <p className="text-sm font-medium text-ink">Abonelikler App Store üzerinden yönetilir.</p>
                <p className="text-[13px] font-light text-ink-muted leading-relaxed">
                  Aboneliğini Apple ID &rarr; Abonelikler bölümünden görüntüleyebilir, değiştirebilir veya iptal
                  edebilirsin.
                </p>
              </div>
              <div className="space-y-5">
                <AppStoreButton testid="membership-appstore-button" />
                {showLink && (
                  <div>
                    <Link to="/uyelik" data-testid="membership-more-link" className="link-ghost">
                      Üyelik hakkında
                      <ArrowRight className="w-4 h-4" aria-hidden="true" />
                    </Link>
                  </div>
                )}
                <p className="text-xs text-ink-muted tracking-wide">18+ · Yalnızca yetişkinler içindir</p>
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
